define('modules/products/activation/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");

    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        initialize: function() {
            this.initRequestEvents();
        },
        url: function() {
            return Config.backendUrl + "/products";
        }
    });

    module.exports = Model;
});

